/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import 'vuetify/styles';

// Composables
import { createVuetify, ThemeDefinition } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';

// Theme
const light: ThemeDefinition = {
  dark: false,
  colors: {
    green: '#1B5E20',
    blue: '#2648BF',
    yellow: '#FFB300',
    orange: '#FF6F00',
    primary: '#000033',
    warning: '#FFC107',
    error: '#D32F2F',
  },
};

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light,
    },
  },
});
